import React, { Fragment, useState } from 'react';
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import AuthorizedFunction from '../security/AuthorizedFunction';
import LayoutPrivate from '@layouts/private/Private';

import { useKeycloak } from '@react-keycloak/web';

import { configureInterceptors } from '@services/API';
import MenuRoutes from '@routes/RoutesConfig';

import MenuProvider from '@contexts/MenuContext';

export const Routes = () => {
  const [keycloak, initialized] = useKeycloak();
  const [darkMode, setDarkMode] = useState(false);

  const handleLogout = () => keycloak.logout();

  const Interceptor = () => {
    configureInterceptors()
    return <Private />
  }

  const theme = createTheme({
    palette: {
      type: darkMode ? 'dark' : 'light'
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Switch>
          {initialized && keycloak.authenticated ?
            <MenuProvider>
              <LayoutPrivate
                handleLogout={handleLogout}
                darkMode={darkMode}
                setDarkMode={setDarkMode}
              >
                <Interceptor />
              </LayoutPrivate>
            </MenuProvider>
          :
            initialized ? keycloak.login() : null
          }
        </Switch>
      </BrowserRouter>
    </ThemeProvider>
  )
}

const renderPrivateComponent = (component, roles) => roles.length === 0 || AuthorizedFunction(roles) ? ( component ) : ( <Redirect to={{ pathname: "" }} /> )
export const MountPrivateRoutes = (props) => {
  return (
    <>
      {props.routes.map((route, key) => {
	
	return <Fragment key={key}>
          <Route
            key={key}
            path={route.path}
            exact
            render={() => renderPrivateComponent(<route.component />, route.roles)}
          />
        </Fragment>;
}

      )}
    </>
  )
}

export const Private = (props) => {
  const menuRoute = MenuRoutes();

  return (
    <Switch>
      {menuRoute.map((sub, key) =>
        <Fragment key={key}>
          <MountPrivateRoutes key={key} routes={sub.items} />
          {sub.items.map((sub, key) =>
            <MountPrivateRoutes key={key} routes={sub.submenus} />
          )}
        </Fragment>
      )}
    </Switch>
  );
}

export default Routes;
